import { ForgotPasswordView } from './forgot-password';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GatewayContent } from './general';
import { InvitationView } from './invitation';
import { OIDCIntegration } from './integrations';
import { ResetPasswordView } from './reset-password';
import { SignupView } from './sign-up';
import { useSonarSelector } from '@hooks';
import { createIsReceivedSelector, createSonarSelector } from '@lib/selectors';
import { LoginRedirectRoute, LoginView } from './login';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
const isLoggingOutSelector = createSonarSelector((state) => state.application.reset.isLoggingOut);
const isLoggingInSelector = createIsReceivedSelector((state) => state.security.authentication.login.post);
export const UnauthorizedView = () => {
    const isLoggingIn = useSonarSelector(isLoggingInSelector);
    const isLoggingOut = useSonarSelector(isLoggingOutSelector);
    useEffect(() => {
        if (isLoggingOut) {
            window.location.reload();
        }
    }, [isLoggingOut]);
    if (isLoggingIn || isLoggingOut) {
        return React.createElement(GatewayContent, null);
    }
    return (React.createElement(GatewayContent, null,
        React.createElement(Routes, null,
            React.createElement(Route, { element: React.createElement(LoginView, null), path: '/' }),
            React.createElement(Route, { element: React.createElement(InvitationView, null), path: FULL_ROUTES.INVITATION }),
            React.createElement(Route, { element: React.createElement(ForgotPasswordView, null), path: FULL_ROUTES.FORGOT_PASSWORD }),
            React.createElement(Route, { element: React.createElement(LoginView, null), path: FULL_ROUTES.LOGIN }),
            React.createElement(Route, { element: React.createElement(ResetPasswordView, null), path: FULL_ROUTES.RESET_PASSWORD }),
            React.createElement(Route, { element: React.createElement(SignupView, null), path: FULL_ROUTES.SIGN_UP }),
            React.createElement(Route, { element: React.createElement(OIDCIntegration, null), path: FULL_ROUTES.INTEGRATIONS_OIDC }),
            React.createElement(Route, { element: React.createElement(LoginRedirectRoute, null), path: '*' }))));
};
